import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import yaml from "js-yaml";
import "../CodeConverter.css";
import { FaDownload, FaCompress, FaBrush, FaCopy, FaCheck, FaTrash } from "react-icons/fa";
import JsonEditorPanel from "../components/JsonEditorPanel";
import CommonSeoContent from "../components/CommonSeoContent";
import useEditorActions from "../utils/useEditorActions";

const YamlToJson = () => {
  const [inputCode, setInputCode] = useState("");
  const [outputCode, setOutputCode] = useState("");

  // Import reusable actions
  const { handleDownload, handleClear } = useEditorActions(
    setInputCode,
    outputCode,
    setOutputCode
  );

  const handleFormat = () => {
    try {
      // parse → stringify again → formatted YAML
      const parsed = yaml.load(inputCode);
      const pretty = yaml.dump(parsed, { indent: 2, lineWidth: 80 });
      setOutputCode(pretty);
    } catch (e) {
      setOutputCode("// ❌ Invalid YAML format: \n "  + e.message);
    }
  };

  return (
    <div className="formatter-container">
      <h1> YAML Formatter</h1>

      {/* Toolbar */}
      <div className="toolbar">
        <button onClick={handleFormat} className="btn primary">
          <FaBrush /> Convert
        </button>
        <button onClick={() => handleDownload("json", "formatted-json")} className="btn success">
          <FaDownload /> Download
        </button>
		<button onClick={handleClear} className="btn danger">
          <FaTrash /> Clear
        </button>

      </div>

      {/* Editors */}
      <div className="editor-panels">
        <JsonEditorPanel title="Input Yaml" language="yaml" code={inputCode} setCode={setInputCode} />
        <div className="editor-section-empty-div">
        </div>
        <JsonEditorPanel title="Output Yaml" language="yaml"  code={outputCode} />
      </div>
	  
	  <CommonSeoContent
  title="Online YAML Formatter and Validator"
  description="Format and validate your YAML code instantly with our free online YAML formatter. Supports indentation correction, error checking, and human-readable output."
  keywords="YAML Formatter, YAML Validator, format YAML online, online YAML tool, yaml beautifier, yaml syntax checker, yaml editor, jsonconverter.org"
  author="jsonconverter.org"
  heading="Why Use YAML Formatter and Validator?"
  whyUseText="Our YAML Formatter and Validator tool helps you clean up, organize, and validate your YAML code in seconds. Whether you're working with configuration files for Kubernetes, Docker, CI/CD pipelines, or other YAML-powered tools, this utility ensures your code is properly indented and syntactically valid. It highlights errors, fixes formatting issues, and gives you a well-structured, human-readable version of your YAML. Best of all, the tool runs 100% in-browser — so your data stays private, secure, and never leaves your device. It's simple, fast, and perfect for developers, DevOps engineers, and system admins."
  howToUseSteps={[
    "Paste your unformatted or raw YAML into the input editor.",
    "Click the Format or Validate button.",
    "View the cleaned-up YAML output instantly.",
    "Fix any syntax errors and copy or download the result.",
  ]}
  features={[
    "Beautifies YAML with consistent indentation and spacing",
    "Real-time syntax validation with error feedback",
    "Highlights invalid characters or structure issues",
    "Supports large YAML files with nested structures",
    "Runs completely in-browser — no data is sent to any server",
    "Free to use anytime — no signup or installation required",
  ]}
  inputTitle="Input YAML:"
  inputExample={`name: John Doe
age: 30
emails:
  - john@example.com
  - john.doe@example.org
isActive: true`}
  outputTitle="Formatted YAML:"
  outputExample={`name: John Doe
age: 30
emails:
  - john@example.com
  - john.doe@example.org
isActive: true`}
  callToAction="Start formatting and validating your YAML instantly — no signup or install required."
/>

    </div>
  );
};

export default YamlToJson;
